const autoNgTemplateLoaderTemplate1 = require('./datatable-searchbar.html');

export const datatableSearchbar = {
  bindings: {
    onChange: '<',
    ngModel: '<',
  },
  templateUrl: autoNgTemplateLoaderTemplate1,
};
